
export class MobileMainItem extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		const li = this.closest("li");
		if (li) {
			const anchor = /** @type {HTMLAnchorElement} */ (li.querySelector(":scope > a"));
			if (anchor) {
				this.render({ href: anchor.href, text: anchor.textContent });
			}
		}
		this.remove();
	}
	
	/**
	 * @param {Record<string, any>} args 
	 */
	render(args = {}) {
		this.insertAdjacentHTML("afterend", `
			<li class="main-section"><a href="${args.href}"><span>${args.text}</span></a></li>
		`);
	}
}

export default MobileMainItem;